module.exports = __webpack_public_path__ + "static/laptop_two-82e3798ffc9853b26104cccac49c3f79.png";